import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { PreviewBody } from "@/components/shapes/shared/card-preview-parts";
import {
  DayAccent,
  EventRows,
} from "@/components/shapes/shared/card-visual-parts";
import { GenericCardPreview } from "@/components/shapes/shared/generic-card-preview";
import { asString } from "@/components/shapes/shared/plain-record";
import { dateParts, toAgendaItems } from "./agenda-items";

const MAX_ROWS = 4;

/**
 * A day's agenda (mockup `.ag`): the date in the accent, then its first
 * rows with colour bars, the current one in bold.
 */
export function AgendaCardPreview(props: CardPreviewProps) {
  const items = (toAgendaItems(props.source.items) ?? []).slice(0, MAX_ROWS);
  if (items.length === 0) return <GenericCardPreview {...props} />;
  const date = asString(props.source.date) || null;
  return (
    <PreviewBody density={props.density} cap="h-[15em]" className="gap-[0.9em]">
      <DayAccent {...dateParts(date)} label={date} />
      <EventRows rows={items} />
    </PreviewBody>
  );
}
